<template>
  <div class="" style="height:100vh"></div>
</template>
<script>
export default {
  name: "pageLoading",
  data() {
    return {
      loading: true
    };
  },
  created() {
    this.loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.3)"
    });
  },
  beforeDestroy() {
    this.loading.close();
  },
  methods: {}
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/page/loading/pageLoading.vue